import { handleCloseAlert, handleShowAlert } from "@src/redux/reducers/alert";
import { ReactElement, createContext, useState } from "react";
import { useDispatch } from "react-redux";


interface ApplicationContextType {
    showAlert: Function,
    hideAlert: Function
}
export const ApplicationContext = createContext<ApplicationContextType>( {} as ApplicationContextType );



interface ChildrenProps {
    children: ReactElement
}

export const ApplicationProvider = ({children}:ChildrenProps) => {
  const dispatch = useDispatch();
  const showAlert = (type: "warning" | "success" | "danger" | "info", children: ReactElement | string) => {
    dispatch(handleShowAlert({type:type , children :children}));
  }
  const hideAlert = () => {
    dispatch(handleCloseAlert())
  }
 
  const [functions, ] = useState<ApplicationContextType>({
    hideAlert,
    showAlert
});

  return <ApplicationContext.Provider value={functions}>{children}</ApplicationContext.Provider>;
};
